import { createI18n } from 'vue-i18n';
import en from './en';
import ja from './ja';
import ko from './ko';
import ms from './ms';
import pt from './pt';
import ru from './ru';
import th from './th';
import vi from './vi';
import zhTw from './zh-tw';
import zh from './zh';
import ar from './ar';
import es from './es';
import { getLocaleFromUrl } from './locale-from-url';

const messages = {
  en,
  ja,
  ko,
  ms,
  pt,
  ru,
  th,
  vi,
  'zh-tw': zhTw,
  zh,
  ar,
  es,
};

// 首屏 locale：URL > 本地缓存 > 系统语言 > en（与 language-loader 优先级对齐）
const getInitialLocale = () => {
  try {
    const fromUrl = getLocaleFromUrl();
    if (fromUrl && Object.keys(messages).includes(fromUrl)) {
      try {
        uni.setStorageSync('locale', fromUrl);
      } catch {
        /* ignore */
      }
      return fromUrl;
    }
  } catch {
    /* ignore */
  }
  try {
    const saved = uni.getStorageSync('locale');
    if (saved && Object.keys(messages).includes(saved)) {
      return saved;
    }
  } catch {
    /* ignore */
  }
  try {
    const lang = uni.getSystemInfoSync().language.toLowerCase();
    if (lang.startsWith('zh-hans')) return 'zh';
    if (lang.startsWith('zh-hant') || lang.startsWith('zh-tw') || lang.startsWith('zh-hk')) {
      return 'zh-tw';
    }
    if (lang.startsWith('zh')) return 'zh';
    const simplifiedLang = lang.split('-')[0];
    if (Object.keys(messages).includes(simplifiedLang)) {
      return simplifiedLang;
    }
    return 'en';
  } catch (error) {
    console.error('Failed to get system locale:', error);
    return 'en';
  }
};

const i18n = createI18n({
  legacy: false, // Use Composition API
  globalInjection: true, // Inject $t for Options API
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  missingWarn: false, // 关闭缺失翻译警告
  fallbackWarn: false, // 关闭回退警告
});

export default i18n;
